import React from 'react';
import Swal from 'sweetalert2';

// Drawer band karne se pehle (outside click ya Cancel) agar kuch unsaved change h to
// hamari apni theme (purple primary) wala sweetalert confirm dikhate h - baaki app me
// jaisa Swal.fire confirm pattern already chalta h, usi se match karte hue.
export const confirmDiscardChanges = async () => {
    const result = await Swal.fire({
        title: 'Are you sure you want to leave?',
        text: "It looks like you're still working on this. Changes you made may not be saved if you leave now.",
        icon: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Leave',
        cancelButtonText: 'Keep editing',
        confirmButtonColor: '#4c5fd5',
        cancelButtonColor: '#6c757d',
    });
    return result.isConfirmed;
};

/** Right-side drawer (header with Cancel/Save, scrollable body). Used by Automations and Funnel. */
export const Drawer = ({ show, title, onClose, onSave, isDirty, readOnly = false, saveLabel = 'Save', closeLabel, children }) => {
    if (!show) return null;

    const requestClose = async () => {
        if (isDirty && !readOnly) {
            const ok = await confirmDiscardChanges();
            if (!ok) return;
        }
        onClose();
    };

    return (
        <>
            <div className="automation-config-drawer-backdrop" onClick={requestClose} />
            <div className="automation-config-drawer">
                <div className="automation-config-drawer-header">
                    <h5 className="m-0">{title}</h5>
                    <div className="drawer-actions">
                        <button type="button" className="btn_theme_secondary" onClick={requestClose}>{closeLabel || (readOnly ? 'Close' : 'Cancel')}</button>
                        {!readOnly && (
                            <button type="button" className="add_app_btn btn_theme_primary" onClick={onSave}><span>{saveLabel}</span></button>
                        )}
                    </div>
                </div>
                <div className="automation-config-drawer-body">
                    {readOnly ? (
                        <>
                            <div className="automation-readonly-note">View only - pause the automation to make changes.</div>
                            <fieldset disabled className="automation-readonly-fieldset">{children}</fieldset>
                        </>
                    ) : children}
                </div>
            </div>
        </>
    );
};